import React, { Component } from 'react';
import { Field, change } from 'redux-form';
import { SkyLightStateless } from 'react-skylight';
import { Breadcrumb, Grid, Row, Col, Panel, ButtonToolbar, Button, Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import classNames from 'classnames';
import _ from 'lodash';
import axios from 'axios';

import ContentWrapper from '../../Layout/ContentWrapper';
import Spinner from '../../../components/Widgets/spinner';
import { Selection, MultiSelection } from '../../Common/selection';
import { DatePicker } from '../../Common/datePicker';
import { formatDate } from '../../Common/dateFormat';
import ConfirmActionModal from '../../Common/confirmActionModal';
import EditAPTable from './editAPTable';
import AccountDropdown from '../../AR/accountDropdown';
import PaymentMethodOptions from '../../Common/arapPaymentOptions';
import { AP_URL } from '../../../actions/url';
import { InputField } from '../../Common/inputField';

class EditAP extends Component {
  state = {
    rows: [],
    unpaidAmount: 0,
    totalAmount: 0,
    checkAuthorizeOpen: false,
    action: null,
    waiveAmount: 0,
    totalPayment: 0,
    isAPEditable: true,
    allCheckNumbers: [],
    checkNumbersInputHasWarning: false,
  };

  componentDidMount() {
    this.props.clearAPForm();
    this.props.clearCredits();
    this.getCheckNumbers();
    const { routeParams: { id } } = this.props;
    if (id) {
      this.props.fetchAPDetail(id);
    } else {
      this.context.router.push('/AP/');
    }
  }

  componentWillReceiveProps(nextProps) {
    // console.log('nextprops', nextprops);
    if (nextProps.apDetail && nextProps.apDetail !== this.props.apDetail) {
      const { Status, Invoices, WaiveAmount, TotalPayment } = nextProps.apDetail;
      const isAPEditable = Status !== 'Void';
      let totalAmount = 0;
      if (Invoices) {
        Invoices.map(invoice => {
          totalAmount += invoice.PreviousBalance;
        });
      }
      this.setState({
        rows: Invoices || [],
        waiveAmount: WaiveAmount,
        totalPayment: TotalPayment,
        totalAmount,
        isAPEditable,
      });
    }
    if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess) {
      this.closeCheckAuthorize();
      if (this.state.action === 'apply') {
        this.handleFormSubmit();
      } else if (this.state.action === 'remove') {
        this.props.deleteAP(this.props.apDetail.Payment_id);
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { totalPayment } = this.state;
    if (totalPayment !== prevState.totalPayment) {
      this.props.dispatch(change('editAP', 'TotalPayment', parseFloat(totalPayment).toFixed(2) || 0));
    }
  }

  getCheckNumbers() {
    axios.get(
      `${AP_URL}check_num/`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        this.setState({
          allCheckNumbers: response.data,
        });
      });
  }

  getBsStyle = (input, value) => ((input === value) ? 'success' : 'primary');

  getBillingAddress() {
    const { apDetail } = this.props;
    let Address1 = '';
    let Address2 = '';
    if (apDetail && apDetail.Vendor_Detail) {
      Address1 = apDetail.Vendor_Detail.Street;
      Address2 = `${apDetail.Vendor_Detail.City}, ${apDetail.Vendor_Detail.State} ${apDetail.Vendor_Detail.Zip}`;
    }
    return [Address1, Address2];
  }

  checkAuthorize = (password) => {
    this.props.checkPassword(password);
  }

  checkPermission(permission) {
    return false;
  }

  openCheckAuthorize = (action) => {
    this.props.clearCheckPassword();
    this.setState({ checkAuthorizeOpen: true, action });
  }

  closeCheckAuthorize = () => {
    this.setState({ checkAuthorizeOpen: false });
  }

  debouncedEditAP = _.debounce((formProps, rows) => {
    this.props.editAP(formProps, rows).then(
      () => {
        if (this.props.apEdited && !this.props.apEditError) {
          this.props.router.push('/AP');
        }
      }
    );
  }, 500, { maxWait: 1000 })

  handleFormSubmit = () => {
    const formProps = {
      PaymentID: this.props.apDetail.Payment_id,
      TotalPayment: parseFloat(this.props.totalPayment || 0).toFixed(2),
      PaymentDate: this.props.paymentDate,
      Method: this.props.method,
      CheckNum: this.props.checkNum,
      Account: this.props.account.value,
      AccountName: this.props.account.label,
      Discount: parseFloat(this.props.discount || 0).toFixed(2),
      Note: this.props.note,
      WaiveAmount: parseFloat(this.state.waiveAmount || 0).toFixed(2),
      TotalAmount: parseFloat(this.state.totalAmount || 0).toFixed(2),
    };
    const { rows } = this.apTable.state;
    this.debouncedEditAP(formProps, rows);
    //TODO show modal ask for staying on the page
  }

  handleWaiveInputChange = (event) => {
    this.setState({
      waiveAmount: event.target.value,
    });
  }

  handlePaymentCellChange = (rows) => {
    let totalPayment = 0;
    let totalAmount = 0;
    rows.map((row) => {
      totalPayment += parseFloat(row.Amount) || 0;
      totalAmount += parseFloat(row.PreviousBalance) || 0;
    });
    this.setState({
      totalPayment,
      totalAmount,
    });
  }

  handlePaymentAmountInputChange = (event) => {
    let payment = parseFloat(event.target.value || 0).toFixed(2) || 0;
    const rows = [...this.state.rows];
    for (let i = 0; i < rows.length; i++) {
      const rowToUpdate = rows[i];
      const { PreviousBalance } = rowToUpdate;
      const unpaidAmount = PreviousBalance || 0;
      if (payment >= unpaidAmount) {
        rowToUpdate.Amount = +parseFloat(unpaidAmount).toFixed(2);
        rowToUpdate.UnpaidAmount = 0;
        payment -= unpaidAmount;
      } else {
        rowToUpdate.Amount = +parseFloat(payment).toFixed(2);
        rowToUpdate.UnpaidAmount = +parseFloat(parseFloat(unpaidAmount) - parseFloat(payment)).toFixed(2);
        payment = 0;
      }
      // overpay condition, add payment to last row
      if (payment > 0 && i === rows.length - 1) {
        rowToUpdate.Amount += +parseFloat(payment).toFixed(2);
        rowToUpdate.UnpaidAmount -= +parseFloat(payment).toFixed(2);
      }
      rows[i] = rowToUpdate;
    }
    this.setState({ rows });
  }

  renderVendors() {
    const { apDetail, apDetailIsLoading, apDetailError } = this.props;
    if (!apDetail || apDetailIsLoading) {
      return <Spinner />;
    } else if (apDetailError) {
      return (
        <ContentWrapper>
          <div className='alert alert-danger'>
            <Translate value="something_unexpected_happened" />
          </div>
        </ContentWrapper>
      );
    }
    const { VendorNum, VendorName, Vendor_Detail } = apDetail;
    let contact = null;
    let phone = null;
    let note = '';
    let billingAddress = ['', ''];

    if (Vendor_Detail) {
      contact = `${Vendor_Detail.FirstName} ${Vendor_Detail.LastName}`;
      phone = Vendor_Detail.Telephone;
      billingAddress = this.getBillingAddress();
      note = Vendor_Detail.Note;
    }
    return (
      <div>
        <Row className='mb0'>
          <Col sm={4}>
            <label className='col-sm-4 inlineLabel' >
              <Translate value="vendor_no" />
              <span style={{ color: 'red' }} >*</span>
            </label>
            <Col sm={8} className='mb-md'>
              <Input
                type='text'
                value={VendorNum}
                disabled
              />
            </Col>
            <label className='col-sm-4 inlineLabel' >
              <Translate value="vendor_name" />
            </label>
            <Col sm={8} className='mb-md'>
              <Input
                type='text'
                value={VendorName}
                disabled
              />
            </Col>
          </Col>
          <Col sm={4}>
            <label className='col-sm-4 inlineLabel' >
              <Translate value="phone" />
            </label>
            <Col sm={8} className='mb-md'>
              <Input
                type='text'
                value={phone}
                disabled
              />
            </Col>
            <label className='col-sm-4 inlineLabel' >
              <Translate value="note" />
            </label>
            <Col sm={8} className='mb-md'>
              <Input
                type='text'
                value={note}
                disabled
              />
            </Col>
          </Col>
          <Col sm={4}>
            <label className='col-sm-3'>
              <Translate value="contact" />:
            </label>
            <Col sm={9}>
              {contact}
            </Col>
            <label className='col-sm-3'>
              <Translate value="address" />:
            </label>
            <Col sm={9}>
              {billingAddress[0]}
              <br />
              {billingAddress[1]}
            </Col>
          </Col>
        </Row>
      </div>
    );
  }

  renderInvoices() {
    if (this.props.invoicesIsLoading && !this.props.invoicesError) {
      return <Spinner />;
    } else if (this.props.invoicesError) {
      return (
        <ContentWrapper>
          <div className='alert alert-danger'>
            <Translate value="something_unexpected_happened" />
          </div>
        </ContentWrapper>
      );
    }
    const { rows } = this.state;
    return (
      <Row>
        <Col sm={12}>
          <EditAPTable
            ref={(apTable) => { this.apTable = apTable; }}
            handlePaymentCellChange={this.handlePaymentCellChange}
            rows={rows}
          />
        </Col>
      </Row>
    );
  }

  renderAPMetaInfo() {
    const { apDetail } = this.props;
    return (
      <Row>
        <Col xs={2}>
          <Row>
            <Col xs={2}>
              <label><Translate value="ID" /></label>
            </Col>
            <Col xs={8}>
              <Input
                type='text'
                value={(apDetail && apDetail.APNum) || ''}
                disabled
              />
            </Col>
          </Row>
        </Col>
        <Col xs={10}>
          <Row>
            <Col xs={3}>
              <Row>
                <Col xs={3} xsOffset={1}>
                  <label><Translate value="user" /></label>
                </Col>
                <Col xs={7}>
                  <Input
                    type='text'
                    value={(apDetail && apDetail.FullName) || 'N/A'}
                    disabled
                  />
                </Col>
              </Row>
            </Col>
            <Col xs={3}>
              <Row>
                <Col xs={4}>
                  <label><Translate value="creation_date" /></label>
                </Col>
                <Col xs={7}>
                  <Input
                    type='text'
                    value={(apDetail && apDetail.PostingDate) ? formatDate(new Date(apDetail.PostingDate)) : 'N/A'}
                    disabled
                  />
                </Col>
              </Row>
            </Col>
            <Col xs={3}>
              <Row>
                <Col xs={4}>
                  <label><Translate value="modified_date" /></label>
                </Col>
                <Col xs={7}>
                  <Input
                    type='text'
                    value={(apDetail && apDetail.ModifyDate) ? formatDate(new Date(apDetail.ModifyDate)) : 'N/A'}
                    disabled
                  />
                </Col>
              </Row>
            </Col>
            <Col xs={3}>
              <Row>
                <Col xs={4}>
                  <label><Translate value="payment_date" /></label>
                </Col>
                <Col xs={7}>
                  <Field name='PaymentDate' component={DatePicker} dropUp maxDate={new Date()} />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }

  handleCheckNumChange(e) {
    const stringValue = "" + e.target.value;
    if (this.state.allCheckNumbers.includes(stringValue) && stringValue !== this.props.originalCheckNumber) {
      this.setState({
        checkNumbersInputHasWarning: true,
      });
    } else {
      this.setState({
        checkNumbersInputHasWarning: false,
      });
    }
  }

  renderCheckNum() {
    return (
      <div>
        <Field name='CheckNum' component={this.renderInputField} handleOnChange={this.handleCheckNumChange.bind(this)} />
        {this.state.checkNumbersInputHasWarning && <p style={{position: "absolute", top: "23px"}}>Reminder: Check num already exists</p>}
      </div>
    );
  }

  renderCredits() {
    if (this.props.creditsIsLoading && !this.props.creditsError) {
      return <Spinner />;
    } else if (this.props.creditsError) {
      return (
        <ContentWrapper>
          <div className='alert alert-danger'>
            <Translate value="something_unexpected_happened" />
          </div>
        </ContentWrapper>
      );
    }
    const creditOptions = this.getCreditOptions(); // Return a JSON in the format of React-Select's options
    return (
      <Field name="Credits" component={MultiSelection} options={creditOptions} />
    );
  }

  renderInputField = (props) => {
    const { meta: { touched, error }, className } = props;
    const inputClass = classNames({ 'parsley-error': touched && error }, 'form-control', className);
    return (
      <div>
        <Input
          {...props.input}
          className={inputClass}
          type='text'
          onChange={(event) => {
            props.input.onChange(event);
            if (typeof props.handleOnChange === 'function') {
              props.handleOnChange(event);
            }
          }}
          disabled={props.disabled}
        />
        {touched && error && <span className='parsley-error-message'>{error}</span>}
      </div>
    );
  }

  renderResponse() {
    const { apEdited, apEditError, apIsEditing } = this.props;
    if (apEdited) {
      return (
        <ContentWrapper>
          <div className='alert alert-success'>Success!</div>
        </ContentWrapper>
      );
    } else if (apIsEditing && !apEditError) {
      return (
        <ContentWrapper>
          <div className='alert alert-info'>
            ...<Translate value="saving" />
          </div>
        </ContentWrapper>
      );
    } // else if (apEditError) {
    //   return (
    //     <ContentWrapper>
    //       <div className='alert alert-danger'>
    //         { apEditError }
    //       </div>
    //     </ContentWrapper>
    //   );
    // }
    return <ContentWrapper />;
  }

  render() {
    const createDialogStyle = {
        width: '550px',
        height: '300px',
        marginLeft: '-15%',
    };

    const { method, submitting } = this.props;
    const { isAPEditable } = this.state;

    const paymentMethodIsCredit = (method === 'Credit' || (method && method.value === 'Credit'));

    const twoDecimalZero = (0).toFixed(2);
    const discount = parseFloat(this.props.discount) || twoDecimalZero;
    const totalAmount = parseFloat(this.state.totalAmount) || twoDecimalZero;
    const balance = (totalAmount - discount).toFixed(2) || twoDecimalZero;
    const waiveAmount = this.state.waiveAmount || twoDecimalZero;
    const totalPayment = parseFloat(this.props.totalPayment) || twoDecimalZero;
    const finalBalance = (balance - waiveAmount - totalPayment).toFixed(2) || twoDecimalZero;

    return (
      <ContentWrapper>
        <form>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Translate value="ar_slashsign_ap" />
            </Breadcrumb.Item>
            <Breadcrumb.Item active='true'>
              <Translate value="account_payable" />
            </Breadcrumb.Item>
          </Breadcrumb> {/* End Navigation Trail */}
          <Grid id='AP-edit'>
            <ButtonToolbar>
              <Button
                bsStyle='danger'
                type='button'
                onClick={() => { this.props.router.push('/AP'); }}
              >
                <em className='fa fa-close' />
              </Button>
            </ButtonToolbar>
            <Panel id='vendors'>
              { this.renderVendors() }
            </Panel>
            <Panel>
              { this.renderInvoices() }
            </Panel>
            <Panel id='check-out-information'>
              { this.renderAPMetaInfo() }
              <div className='horizontal-divider' />
              <Row className="upper-row-positioning">
                <Col sm={1}>
                  <label className='text-nowrap inlineLabel' >
                    <Translate value="payment_method" />
                    <span className='asteriksReq'>*</span>
                  </label>
                </Col>
                <Col sm={2}>
                  <Field
                    name='Method'
                    className='select-menu-drop-up'
                    component={Selection}
                    options={PaymentMethodOptions}
                    disabled={!isAPEditable}
                  />
                </Col>
                <Col sm={1}>
                  <label className='inlineLabel' >
                    <Translate value="check_number" />
                  </label>
                </Col>
                <Col sm={2}>
                  { paymentMethodIsCredit && this.renderCredits() }
                  { !paymentMethodIsCredit && this.renderCheckNum() }
                </Col>
                <Col sm={2}>
                  <Row>
                    <Col sm={6}>
                      <label className='inlineLabel' >
                        <Translate value="discount" /> ($)
                      </label>
                    </Col>
                    <Col sm={6}>
                      <Field
                        name='Discount'
                        component={this.renderInputField}
                        disabled
                      />
                    </Col>
                  </Row>
                </Col>
                {/* Waive section */}
                <Col sm={2}>
                  <Row>
                    <Col sm={2}>
                      <label className='inlineLabel' >
                        <Translate value="waive" />
                      </label>
                    </Col>
                    {/*
                      <Col sm={2}>
                        <Field name='Waive' component={this.renderWaiveCheckbox} />
                      </Col>
                    */}
                    <Col sm={6} smOffset={1}>
                      <Field
                        name='WaiveAmount'
                        component={this.renderInputField}
                        handleOnChange={this.handleWaiveInputChange}
                        disabled
                      />
                    </Col>
                  </Row>
                </Col>
                {/* End waive section */}
                <Col sm={1}>
                  <label>
                    <Translate value="balance" /> :
                  </label>
                </Col>
                <Col sm={1}>
                  <label>
                    { balance }
                  </label>
                </Col>
              </Row>
              <Row className="lower-row-positioning">
                <label className='col-sm-1 inlineLabel' >
                  <Translate value="account" />
                  <span style={{ color: 'red' }} >*</span>
                </label>
                <Col sm={2}>
                  <AccountDropdown className='select-menu-drop-up' disabled={!isAPEditable} />
                </Col>
                <label className='col-sm-1 text-nowrap inlineLabel' >
                  <Translate value="pay_amount" />
                  <span className='asteriksReq'>*</span>
                </label>
                <Col sm={2} className="total-payment-field">
                  <Field
                    name='TotalPayment'
                    component={this.renderInputField}
                    handleOnChange={this.handlePaymentAmountInputChange}
                    disabled={!isAPEditable}
                  />
                </Col>
                <Col sm={1}>
                  <label className='inlineLabel' >
                    <Translate value="note" />
                  </label>
                </Col>
                <Col sm={2}>
                  <Field
                    name='Note'
                    component={this.renderInputField}
                    disabled={!isAPEditable}
                  />
                </Col>
                <label className='col-sm-1 col-sm-offset-1'>
                  <Translate value="final_balance" /> :
                </label>
                <label className='col-sm-1'>
                  { finalBalance }
                </label>
              </Row>
              <div className="horizontal-divider divider" />
              <Row id='hint'>
                <Col sm={4} className='vertical-divider'>
                  <ButtonToolbar id="ap-apply-button">
                    <Button
                      bsStyle='success'
                      type='button'
                      onClick={() => { this.openCheckAuthorize('apply'); }}
                      disabled={submitting || !isAPEditable}
                    >
                      <em className="fa fa-save" /><Translate value="save" />
                    </Button>
                    <Button
                      bsStyle='danger'
                      type='button'
                      onClick={() => { this.openCheckAuthorize('remove'); }}
                      disabled={submitting || !isAPEditable}
                    >
                      <Translate value="remove" />
                    </Button>
                  </ButtonToolbar>
                </Col>
                <Col sm={5}>
                  <label className='authorize-label'>
                    <Translate value="authorization_required" />
                  </label>
                </Col>
              </Row>
            </Panel>
            <Row>
              {this.renderResponse()}
            </Row>
          </Grid>
        </form>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.checkAuthorizeOpen}
          onCloseClicked={this.closeCheckAuthorize}
        >
          <ConfirmActionModal
            case='confirmPassword'
            closeC={this.checkAuthorize}
            checkPasswordFailure={this.props.checkPasswordFailure}
          />
        </SkyLightStateless>
      </ContentWrapper>
    );
  }
}

export default EditAP;



// WEBPACK FOOTER //
// ./master/jsx/components/AP/EditAP/editAP.jsx